function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import Axios from 'axios';
import { nearestTown } from '../../constants/api';
import { PATH } from '../../envs/core';
export const nearestTownRest = (townId, latitude, longitude) => {
  const id = "id=".concat(townId);
  const lat = "&lat=".concat(latitude);
  const lon = "&lon=".concat(longitude);
  const filter = "".concat(id).concat(lat).concat(lon, "&size=20");
  return Axios.get("".concat(PATH).concat(nearestTown).concat(filter)).then(response => {
    return response;
  });
};
export const NearestTownProvider = ({
  townId,
  longitude,
  latitude,
  children
}) => {
  const _useState = useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        data = _useState2[0],
        setData = _useState2[1];

  useEffect(() => {
    nearestTownRest.then(response => {
      setData(response.data.content);
    });
  }, [townId, latitude, longitude]);
  return children(data);
};
NearestTownProvider.propTypes = {
  townId: PropTypes.string.isRequired,
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired
};
NearestTownProvider.defaultProps = {
  latitude: 0,
  longitude: 0
};